module.exports = new __parcel__URL__("periscope-page-with-activity.tpl.5d51442a.svg").toString();